module.exports = require('./helpers/bundle-url').getBundleURL('bLxZJ') + "javascript-vertical.7366dada.svg" + "?" + Date.now();